/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

console.log('Ecomify Theme - Premium Shopify Theme by EcomGraduates.com | Learn more at https://www.ecomgraduates.com')

// Preserve the active Shopify Market/locale for Ajax and cart routes.
window.shopifyRoutesRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'

// Init Bootstrap tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach((el) => new bootstrap.Tooltip(el))

// Init Bootstrap popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach((el) => new bootstrap.Popover(el))

// Shopify's callenge page - Add BS classes
document.querySelector('.btn.shopify-challenge__button')
    ?.classList.add('btn-primary')

// Shopify's errors messages - Add BS classes
const errors = document.querySelector('.errors')
if (errors) {
    errors.classList.add('alert', 'alert-danger')
}

// Shopify's money format
Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '')
    }

    let value = ''
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
    const formatString = (format || this.money_format)

    function defaultOption (opt, def) {
        return (typeof opt === 'undefined' ? def : opt)
    }

    function formatWithDelimiters (number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2)
        thousands = defaultOption(thousands, ',')
        decimal = defaultOption(decimal, '.')

        if (isNaN(number) || number == null) {
            return 0
        }

        number = (number / 100.0).toFixed(precision)

        const parts = number.split('.')
        const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
        const cents = parts[1] ? (decimal + parts[1]) : ''

        return dollars + cents
    }

    switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
        value = formatWithDelimiters(cents, 2)
        break
    case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0)
        break
    case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',')
        break
    case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',')
        break
    }

    return formatString.replace(placeholderRegex, value)
}

// Resize Shopify images - helper function
// https://gist.github.com/DanWebb/cce6ab34dd521fcac6ba
Shopify.resizeImage = (src, size, crop = '') => src.replace(/_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g, '.')
    .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
            // eslint-disable-next-line no-param-reassign
            crop = `_crop_${crop}`
        }
        return `_${size}${crop}${match}`
    })

// Debounce - helper function
window.debounce = (callback, wait = 200) => {
    let timeout
    return (...args) => {
        const context = this
        clearTimeout(timeout)
        timeout = setTimeout(() => callback.apply(context, args), wait)
    }
}

// Throttle - helper function
window.throttle = (callback, timeFrame = 200) => {
    let lastTime = 0
    return function () {
        const now = Date.now()
        if (now - lastTime >= timeFrame) {
            callback()
            lastTime = now
        }
    }
}

// Create cookie - helper function
window.createCookie = (name, value, days) => {
    let date, expires
    if (days) {
        date = new Date()
        date.setDate(date.getDate() + days)
        expires = '; expires=' + date.toUTCString()
    } else {
        expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
}

// Detect elements when they are within view
// https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
const initEnterView = () => {
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('entered')

                entry.target.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
                    el.classList.remove('opacity-0')
                    el.classList.add(el.dataset.animateClass)
                })
            }
        })
    }, { threshold: 0, rootMargin: '0px 0px -200px 0px' })

    document.querySelectorAll('.enter-view').forEach((el) => {
        observer.observe(el)
    })
}
initEnterView()

// License key
// WARNING: DO NOT REMOVE THIS CODE OTHERWISE
// YOUR THEME MIGHT STOP WORKING
const initLicenseKey = async () => {
    if (Shopify.designMode) {
        console.log(window.ecomify_license_key)
        window.ecomify_license_code = window.ecomify_license_key
        const shop = window.Shopify.shop
        const key = window.ecomify_license_code
        let msg = ''
        if (key.length) {
            const response = await fetch(`https://license.graduatesapi.com/check?store=${shop}&license=${key}`)
            console.log(response)
            const data = await response.json()
            console.log(data)
            if (data.valid) {
                return
            } else {
                msg = `The license key you have provided for this store (${shop}) is invalid. Please add a new license key.`
            }
        } else {
            msg = `You must add your unique Ecomify license key in the "Theme Settings" to activate Ecomify Theme for this store (${shop}).`
        }
        document.body.insertAdjacentHTML('afterbegin', `
            <div
                class="position-fixed w-100 h-100" 
                style="background: rgba(0, 0, 0, .5); backdrop-filter: blur(15px); z-index: 9999999999;"> 
                <div
                    class="alert alert-warning position-fixed top-50 start-50 translate-middle text-center fw-bold" 
                    style="background-color: var(--bs-warning);">
                    ${msg}
                </div>
            </div>
        `)
    }
}
initLicenseKey()

if (Shopify.designMode) {
    setTimeout(() => {
        if (window.ecomify_license_code === undefined || window.ecomify_license_key === undefined) {
            document.documentElement.remove()
        } else if (window.ecomify_license_code.length < 28 || window.ecomify_license_code.length > 32) {
            if (!document.querySelector('.alert.alert-warning.position-fixed.top-50.start-50')) {
                document.documentElement.remove()
            }
        }
    }, 4000)
}

// Lazy load HTMl5 videos
// https://web.dev/lazy-loading-video/
const initVideoLazyLoad = () => {
    const lazyVideos = [].slice.call(document.querySelectorAll('video.lazy-video'))

    if ('IntersectionObserver' in window) {
        const lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (const source in video.target.children) {
                        const videoSource = video.target.children[source]
                        if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                            videoSource.src = videoSource.dataset.src
                        }
                    }

                    video.target.load()

                    if (video.target.hasAttribute('data-poster')) {
                        video.target.poster = video.target.dataset.poster
                    }

                    video.target.classList.remove('lazy-video')
                    lazyVideoObserver.unobserve(video.target)
                }
            })
        }, { threshold: 0, rootMargin: '0px 0px 200px 0px' })

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo)
        })
    }
}
initVideoLazyLoad()

document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('.enter-view').forEach((elem) => {
        elem.classList.add('entered')
        document.querySelectorAll('.animate__animated.opacity-0').forEach((el) => {
            el.classList.remove('opacity-0')
        })
    })
})
